var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83854 13.9999C5.68912 14.0004 5.54148 13.9675 5.40648 13.9034C5.27147 13.8394 5.15253 13.746 5.0584 13.63L0.227529 7.63053C0.0804207 7.45162 0 7.2272 0 6.99559C0 6.76399 0.0804207 6.53957 0.227529 6.36065L5.22843 0.361218C5.3982 0.157021 5.64215 0.0286085 5.90663 0.0042311C6.1711 -0.0201463 6.43443 0.0615079 6.63868 0.23123C6.84294 0.400953 6.97138 0.644841 6.99577 0.909243C7.02015 1.17364 6.93848 1.4369 6.76871 1.6411L2.2979 7.00059L6.61868 12.3601C6.74098 12.5069 6.81868 12.6856 6.84256 12.8751C6.86644 13.0646 6.83552 13.257 6.75345 13.4296C6.67138 13.6021 6.5416 13.7475 6.37946 13.8485C6.21732 13.9496 6.02961 14.0022 5.83854 13.9999Z",
    fill: "#F47B34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.d362cb04c01ef8afe6c646fda9f4455c.svg";
export { ForwardRef as ReactComponent };